import { BsModalRef } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss']
})
export class TicketComponent implements OnInit {
  idOrder: number;
  @ViewChild('ticket') ticket: ElementRef;
  ticketContent: any;
  num: null;
  loading = true;
  constructor(
    private ordersService: OrdersService,
    private toastr: ToastrService,
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    setTimeout(
      () => {
        if (this.idOrder && this.idOrder != 0) {
          this.ordersService.getOrderTicket(this.idOrder).subscribe(
            (resp: any) => {
              this.ticketContent = resp.template
              this.loading = false;
              this.num = resp.num;
            }
          )
        }
      }, 200
    )
  }
  printTicket() {
    var elem = document.getElementById("printThis")
    var domClone = elem.cloneNode(true);

    var $printSection = document.getElementById("printSection");

    if (!$printSection) {
      $printSection = document.createElement("div");
      $printSection.id = "printSection";
      document.body.appendChild($printSection);
    }
    $printSection.innerHTML = "";
    $printSection.appendChild(domClone);
    window.print();
  }
}
